/**
 * @file
 */

import { hideFieldErrorPrompt, IsIntlValid, ValidateGroup } from "@/common/validation/utils.js";
import { aspControlValidationInit, customValidationInit } from "@/common/validation/init.js";
import { sectionDisplay } from "@/common/common.js";

// global variables for the summary check logic
var FIELD_LABEL = 0;
var FIELD_VALUE = 1;
var FIELD_ID = 2;
var FIELD_ORIG_VALUE = 3;
var FIELD_ID_PARENT = 3;
var radioSelected = "";

var originalValues = [];   // values populated upon initial load
var changedValues = [];    // values that are different from the original values
var saveChanges = false;   // boolean set by modal 'OK' button processing to tell page click event to postback and save changes.

export function InitializeProfilePage() {
   // declare field variables for the summary check logic
   var fieldLabel = "";
   var fieldValue = "";
   var fieldID = "";
   var fieldIDParent = "";
   $('#tabs').tabs();

   $('.jquery-tab-nav li').click(function () { 
      // how to set the active tab
      //$( "#tabs" ).tabs( "option", "active", 1 );
      // how to get the active tab
      var active = $('#tabs').tabs( "option", "active" );
       if (active === 1) {
         $("div[id$='divAccountSelector']").hide();
      } else {
         $("div[id$='divAccountSelector']").show();
      }
   });

   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   // --------------------------------------------------------------------------
   // stand up a click monitor to show mobile consent if phone is mobile
   // checkbox gets checked, and hide if unchecked
   // --------------------------------------------------------------------------
   $(".cbIsMobile input[type='checkbox']").click(function (e) {
      var cbDomesticHomeIsMobile = $(':checkbox[id$="chkPrimaryPhoneDomesticIsMobile"]');
      var cbDomesticAlternateIsMobile = $(':checkbox[id$="chkAlternatePhoneDomesticIsMobile"]');
      var cbDomesticWorkIsMobile = $(':checkbox[id$="chkWorkPhoneDomesticIsMobile"]');

      var cbIntlHomeIsMobile = $(':checkbox[id$="chkPrimaryPhoneIntlsMobile"]');
      var cbIntlAlternateIsMobile = $(':checkbox[id$="chkAlternatePhoneIntlIsMobile"]');
      var cbIntlWorkIsMobile = $(':checkbox[id$="chkWorkPhoneIntlIsMobile"]');

      var suppressionStatus = $("[id$='hdnSuppressionStatus']").val();

      if (suppressionStatus === 'CANCALL') {
          if (cbDomesticHomeIsMobile.is(':checked')) {
             sectionDisplay('divConsent', 'show');
          } else if (cbDomesticWorkIsMobile.is(':checked')) {
             sectionDisplay('divConsent', 'show');
          } else if (cbDomesticAlternateIsMobile.is(':checked')) {
             sectionDisplay('divConsent', 'show');
          } else if (cbIntlHomeIsMobile.is(':checked')) {
             sectionDisplay('divConsent', 'show');
          } else if (cbIntlWorkIsMobile.is(':checked')) {
             sectionDisplay('divConsent', 'show');
          } else if (cbIntlAlternateIsMobile.is(':checked')) {
             sectionDisplay('divConsent', 'show');
          } else {
             sectionDisplay('divConsent', 'hide');
          }
      }
   });

   //set up logic for redirects to a specific tab on this page
   var deeplink = location.hash;
   var tab = $('a.ui-tabs-anchor[href="' + deeplink + '"]').closest('li[role="tab"]');
   if (tab[0]) {
      var idx = $(tab).siblings().addBack().index(tab);
      $('#tabs').tabs('option', 'active', idx);
   }

   //set up events for when the drop down lists change
   $('select[id$="ddlCountry"]').change(ddlCountry_SelectedIndexChanged);
   $('select[id$="ddlPrimaryPhoneType"]').change(phoneTypeChanged);
   $('select[id$="ddlAlternatePhoneType"]').change(phoneTypeChanged);
   $('select[id$="ddlWorkPhoneType"]').change(phoneTypeChanged);

   //set up input mask for domestic phone number            
   // note the question mark indicating that the mask is optional
   // this accounts for when the user only enters a partial number and then clicks submit
   // without the optional setting, JQUERY clears the field and then proceeds with the update
   // pcf 3/23/2015 - removed the question mark since it should not be necessary any longer
   // since the validation engine is validating these fields.  Also with it and the validation
   // engine present it was causing weird results with the field.
   $("#txtPrimaryPhoneNumber").mask("(999) 999-9999");
   $("#txtAlternatePhoneNumber").mask("(999) 999-9999");
   $("#txtWorkPhoneNumber").mask("(999) 999-9999");
//   $("#txtTextNumber").mask("(999) 999-9999");

   // perform the summary check logic over all elements that have the class 'summaryCheck'
   // store the values of those elements in the global array originalValues
   var addRow;
   $('.summaryCheck').each(function (index) {
      addRow = true;
      // get the id of the element, it's value, and the text of the associated label
      fieldID = $(this).attr("id");
      fieldValue = $(this).val();
      fieldIDParent = "";
      fieldLabel = $("label[for='" + fieldID + "']").children('span.label-text').html();
      if (fieldID !== undefined) {
         if ($(this).is("select")) {
            fieldValue = $("#" + fieldID + " :selected").text();
         } else if ($(this).is("input[type=checkbox]")) {
            fieldValue = "No";
            if ($(this).is(":checked"))
               fieldValue = "Yes";
         }
         else if ($(this).is('[id*="rblOptions"]')) {
            if ($(this).is(":checked")) {
               fieldValue = $(this).val();
               fieldIDParent = $(this).closest("table").attr("id");
               fieldLabel = "Mobile Phone Consent";
            } else {
               addRow = false;
            }
                                 
         }
         else {
            fieldValue = $(this).val();
         }


         if (fieldID.indexOf("Phone") != -1) {
            addRow = false;
            if (fieldID.indexOf("CountryCode") != -1) {
               addRow = true;
               var intlNumber;
               if (fieldID.indexOf("Primary") != -1) {
                  intlNumber = getPrimaryInternational();
                  fieldLabel = "Primary Phone International";
               } else if (fieldID.indexOf("Alternate") != -1) {
                  intlNumber = getAlternateInternational();
                  fieldLabel = "Alternate Phone International";
               } else if (fieldID.indexOf("Work") != -1) {
                  intlNumber = getWorkInternational();
                  fieldLabel = "Work Phone International";
               } else {
                  intlNumber = "";
               }
               fieldValue = intlNumber[0];
            } else if (fieldID.indexOf("Number") != -1) {
               addRow = true;
               if (fieldID.indexOf("Primary") != -1) {
                  fieldLabel = "Primary Phone";
               } else if (fieldID.indexOf("Alternate") != -1) {
                  fieldLabel = "Alternate Phone";
               } else if (fieldID.indexOf("Work") != -1) {
                  fieldLabel = "Work Phone";
               }
            } else if (fieldID.indexOf("FnExt") != -1) {
               addRow = true;
               fieldLabel = "Work Extension International";
            } else if (fieldID.indexOf("Extension") != -1) {
               addRow = true;
               fieldLabel = "Work Extension";
            } else if (fieldID.indexOf("DomesticIsMobile") != -1) {
               addRow = true;
               if (fieldID.indexOf("Primary") != -1) {
                  fieldLabel = "Primary Is Mobile";
               } else if (fieldID.indexOf("Alternate") != -1) {
                  fieldLabel = "Alternate Is Mobile";
               } else if (fieldID.indexOf("Work") != -1) {
                  fieldLabel = "Work Is Mobile";
               }
            } else if (fieldID.indexOf("IntlIsMobile") != -1) {
               addRow = true;
               if (fieldID.indexOf("Primary") != -1) {
                  fieldLabel = "Primary International Is Mobile";
               } else if (fieldID.indexOf("Alternate") != -1) {
                  fieldLabel = "Alternate International Is Mobile";
               } else if (fieldID.indexOf("Work") != -1) {
                  fieldLabel = "Work International Is Mobile";
               }
            }
         }

         if (fieldValue == "") {
            fieldValue = "(No Value)";
         }

         if (addRow) {
            // push those items onto a row 
            var row = [];
            row.push(fieldLabel);
            row.push(fieldValue);
            row.push(fieldID);
            row.push(fieldIDParent);
            // push that row onto the original values array
            originalValues.push(row);
         }
      }
   });

   $("[id$='divSummaryReviewDialog']").dialog({
      autoOpen: false,
      modal: true,
      resizable: false,
      width: "auto",
      dialogClass: "dlgSummaryReview",
      buttons: {
         "OK": {
            text: "OK",
            class: 'primary',
            click: function () {
               saveChanges = true;
               $("[id$='btnAddressSave']").click();
            }
         },
         "CANCEL": {
            text: "CANCEL",
            class: 'secondary',
            click: function () {
               $(this).dialog("close");
            }
         }
      }
   });

   $("[id$='divNoChangesDialog']").dialog({
      autoOpen: false,
      modal: true,
      resizable: false,
      width: "auto",
      dialogClass: "dlgNoChange",
      buttons: {
         "OK": {
            text: "OK",
            class: 'twoColorButton',
            click: function () {
               $(this).dialog("close");
            }
         }
      }
   });

   window.scrollTo({ top: 0 });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-10
  window.handleAddressSaveClick = handleAddressSaveClick;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-10
  window.handleNotificaitonSaveClick = handleNotificaitonSaveClick;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-10
  window.checkPaperless = checkPaperless;
};

// do the summary check logic - check all the appropriate elements original values vs. current.
// add to the alert text any element that changed and needs to be reviewed by the borrower.
// If there are no changes then inform the borrower and return to the profile page.
function review() {
   var fieldID, fieldValue, currentValue, fieldIDParent;

   // loop over the original values.  if any do not match the current values
   // of the fields then push those items onto a changed values array.
   changedValues = [];
   for (var i = 0; i < originalValues.length; i++) {
      fieldID = originalValues[i][FIELD_ID];
      fieldValue = originalValues[i][FIELD_VALUE];
      fieldIDParent = originalValues[i][FIELD_ID_PARENT];

      if ($("[id$='" + fieldID + "']").is("select")) {
         currentValue = $("[id$='" + fieldID + "'] :selected").text();
      } else if ($("[id$='" + fieldID + "']").is("input[type=checkbox]")) {
         currentValue = "No";
         if ($("[id$='" + fieldID + "']").is(":checked"))
            currentValue = "Yes";
      } else if ($("[id*='" + fieldIDParent + "']").is("table")) {
         if ($("[id*='" + fieldIDParent + "']").is(":checked")) {
            currentValue = $("[id*='" + fieldIDParent + "']:checked").val();
         }
      } else {
         currentValue = $("[id$='" + fieldID + "']").val();
      }

      if (fieldID.indexOf("CountryCode") != -1) {
         var intlNumber;
         if (fieldID.indexOf("Primary") != -1) {
            intlNumber = getPrimaryInternational();
         } else if (fieldID.indexOf("Alternate") != -1) {
            intlNumber = getAlternateInternational();
         } else if (fieldID.indexOf("Work") != -1) {
            intlNumber = getWorkInternational();
         } else {
            intlNumber = "";
         }
         currentValue = intlNumber[0];
      }

      if (currentValue == "") {
         currentValue = "(No Value)";
      }

      if (fieldValue != currentValue) {
         var row = [];
         row.push(originalValues[i][FIELD_LABEL]);
         row.push(currentValue);
         row.push(fieldID);
         row.push(fieldValue);
         changedValues.push(row);
      }
   }

   // if we have changed items then setup the confirm box
   if (changedValues.length > 0) {
      displaySummaryReview();

   } else {
      $("[id$='divNoChangesDialogContent']").html("You have not made any updates. Click 'OK' to return to the profile page.");
      $("[id$='divNoChangesDialog']").dialog("open");

   }
};

function displaySummaryReview() {
   var outputString = "<p>Please review the following changes you have entered before submitting your profile updates.</p>"
                     + "<table class='summaryReviewTable' datatable='true'>"
                     + "<colgroup><col style='width: 33%;'/><col style='width: 66%;'/></colgroup>"
                     + "<thead><tr><th>Field</th><th>New Value</th></tr></thead>";
                       
   for (var i = 0; i < changedValues.length; i++) {
       if (!$('#' + changedValues[i][FIELD_ID]).closest('div.profileField').hasClass('ui-helper-hidden')) {
         outputString = outputString + "<tr><td>" + changedValues[i][FIELD_LABEL] + "</td>"
                                    + "<td>" + changedValues[i][FIELD_VALUE] + "</td></tr>";
      }
   }

   outputString = outputString + "</table><br />"
                              + "Click 'OK' to proceed or 'Cancel' to return to the profile screen.";

   $("[id$='divSummaryReviewDialogContent']").html(outputString);

   $("[id$='divSummaryReviewDialog']").dialog("open");

}

function validateSaveProfile() {
   var isValid = true;

   var groupName = "cvg_PhoneAddress";
   var $group = $('[id$="pnlAddrPhone"]');

   isValid = ValidateGroup($group, groupName);

   return isValid;
}

// function called for the client click.  We need to make sure validation runs prior to the summary
// check logic so we call isPageValid() first.  If that page validates then we call reviewSuccessful.
function handleAddressSaveClick() {
   if (validateSaveProfile()) {
      if (saveChanges) {
         return true;
      } else {
         review();
         return false;
      }
   } else {
      return false;
   }
}

function validateSaveNotification() {
   var isValid = true;

   var groupName = "cvg_ProfileNotification"
   var $group = $('[id$="pnlDefaultNotificationButton"]');

   isValid = ValidateGroup($group, groupName);

   return isValid;
}

function handleNotificaitonSaveClick() {
   if (checkPaperless()) {
      if (validateSaveNotification()) {
         return true;
      } else {
         return false;
      }
   } else {
      return false;
   }
}

// --------------------------------------
// Hide/Show State or Province field     
// reset all "state" oriented fields    
// if country changes                    
// --------------------------------------
function ddlCountry_SelectedIndexChanged() {
   var type = $('select[id$="ddlCountry"]').val();
   var isIntl = (type.toLowerCase() != 'us');

   $("div[id$='divState']").toggleClass('ui-helper-hidden', isIntl);
   $("div[id$='divProvince']").toggleClass('ui-helper-hidden', !isIntl);

   $("[id$='txtProvince']").val('');
   $("[id$='txtZipcode']").val('');

   hideFieldErrorPrompt("txtZipcode");
}

// ---------------------------------------
// Hide/Show Domestic or INTL phone field 
// Clear input fields when type is changed
// ---------------------------------------
function phoneTypeChanged() {
    var type = $(this).val();
    var row = $(this).closest("[class$='phone']");
    var isIntl = (type.toLowerCase() == 'intl');

    row.find('.fmt-us').toggleClass('ui-helper-hidden', isIntl);
    row.find('.fmt-intl').toggleClass('ui-helper-hidden', !isIntl);

    row.find('input[type=tel]').val('');

    // clear validation of the phone number fields when changing between phone types
    // NOTE:  we are clearing the error prompts of the fields being changed 'from' not the fields we're going 'to'
    hideFieldErrorPrompt(row.find('input[type=tel]').attr("id"));

}

// ------------------------------------------------------------------------
// Phone Number Accessors 
// ------------------------------------------------------------------------
function getPrimaryDomestic() {
   return $.trim($('input[id$="txtPrimaryPhoneNumber"]').val());
}

function getPrimaryInternational() {
   var primaryInternational = "";
   var countryCode = $('input[id$="txtPrimaryPhoneCountryCode"]').val();
   var cityCode = $('input[id$="txtPrimaryPhoneCityCode"]').val();
   var local = $('input[id$="txtPrimaryPhoneLocal"]').val();

   primaryInternational = $.trim(countryCode) + " " + $.trim(cityCode) + " " + $.trim(local);
   primaryInternational = primaryInternational.trim();

   return [primaryInternational, countryCode, cityCode, local];
}

function getPrimaryNumber() {
   var primaryNumber = "";
   var intlValid = true;

   // *** Primary Number ***
   var phoneType = $('select[id$="ddlPrimaryPhoneType"]').val().toUpperCase();
   if (phoneType == 'INTL') {
      var intlNumbers = getPrimaryInternational();
      primaryNumber = intlNumbers[0];
      // see if international number is valid 
      intlValid = IsIntlValid(intlNumbers[1], intlNumbers[2], intlNumbers[3]);
   } else {
      primaryNumber = getPrimaryDomestic();
   }
   if (primaryNumber != "") {
      primaryNumber = removeSpecialCharacters(primaryNumber);
   }

   return [primaryNumber, intlValid];
}

function getAlternateDomestic() {
   return $.trim($('input[id$="txtAlternatePhoneNumber"]').val());
}

function getAlternateInternational() {
   var alternateInternational = "";
   var countryCode = $('input[id$="txtAlternatePhoneCountryCode"]').val();
   var cityCode = $('input[id$="txtAlternatePhoneCityCode"]').val();
   var local = $('input[id$="txtAlternatePhoneLocal"]').val();

   alternateInternational = $.trim(countryCode) + " " + $.trim(cityCode) + " " + $.trim(local);
   alternateInternational = alternateInternational.trim();

   return [alternateInternational, countryCode, cityCode, local];
}

function getAlternateNumber() {
   var alternateNumber = "";
   var intlValid = true;

   // *** alternate Number ***
   var phoneType = $('select[id$="ddlAlternatePhoneType"]').val().toUpperCase();
   if (phoneType == 'INTL') {
      var intlNumbers = getAlternateInternational();
      alternateNumber = intlNumbers[0];
      // see if international number is valid
      intlValid = IsIntlValid(intlNumbers[1], intlNumbers[2], intlNumbers[3]);
   } else {
      alternateNumber = getAlternateDomestic();
   }
   if (alternateNumber != "") {
      alternateNumber = removeSpecialCharacters(alternateNumber);
   }

   return [alternateNumber, intlValid];
}

function getWorkDomestic() {
   return $.trim($('input[id$="txtWorkPhoneNumber"]').val());
}

function getWorkInternational() {
   var workInternational = "";
   var countryCode = $('input[id$="txtWorkPhoneCountryCode"]').val();
   var cityCode = $('input[id$="txtWorkPhoneCityCode"]').val();
   var local = $('input[id$="txtWorkPhoneLocal"]').val();

   workInternational = $.trim(countryCode) + " " + $.trim(cityCode) + " " + $.trim(local);
   workInternational = workInternational.trim();

   return [workInternational, countryCode, cityCode, local];
}

function getWorkNumber() {
   var workNumber = "";
   var intlValid = true;

   // *** work Number ***
   var phoneType = $('select[id$="ddlWorkPhoneType"]').val().toUpperCase();
   if (phoneType == 'INTL') {
      var intlNumbers = getWorkInternational();
      workNumber = intlNumbers[0];
      // see if international number is valid
      intlValid = IsIntlValid(intlNumbers[1], intlNumbers[2], intlNumbers[3]);
   } else {
      workNumber = getWorkDomestic();
   }
   if (workNumber != "") {
      workNumber = removeSpecialCharacters(workNumber);
   }

   return [workNumber, intlValid];
}

function checkPaperless() {
   // if the paperless div is visible then the borrower is currently on paperless
   if ($('div[id$="divPaperlessEnrolled"]').is(':visible')) {
      // confirm 
      var result = confirm("Please confirm you no longer want to receive your correspondence electronically.");
      if (result) {
         return true;
      } else {
         //$('input[id$="chkPaperless"]').prop("checked", true);
         return false;
      }
   }

   return true;
}

// --------------------------------------
// Final Check
//  this routine performs final edits
//  before posting back. It checks for:
//  1) Same Phone Number in multiple fields
//  2) All Phone Number fields are empty
// --------------------------------------
export function FinalProfileChecks(field, rules, i, options) {
   var errorMsg;

   if (options.performFinalChecks) {
      var fieldId = field.attr("id");

      if (fieldId.indexOf("Alternate") != -1) {
         // get necessary numbers
         var alternate = getAlternateNumber();
         var phoneType = $('select[id$="ddlAlternatePhoneType"]').val().toUpperCase();

         var validINTL = alternate[1];

         if ((phoneType == 'US') || ((phoneType == 'INTL') && validINTL)) {
            var primary = getPrimaryNumber();
            // check alternate vs primary phone numbers
            if (alternate[0] != "") {
               if (alternate[0] == primary[0])
                  errorMsg = "Alternate phone number cannot be the same as the Primary phone number.  Please change or remove the duplicate.";
            }
         } else if ((phoneType == 'INTL') && !validINTL) {
            errorMsg = "Alternate phone number that is International must include Country Code, City code, and Local.";
         }
      } else if (fieldId.indexOf("Work") != -1) {
         // get necessary numbers
         var primary = getPrimaryNumber();
         var alternate = getAlternateNumber();
         var work = getWorkNumber();

         var phoneType = $('select[id$="ddlWorkPhoneType"]').val().toUpperCase();
         var validINTL = work[1];

         if ((phoneType == 'US') || ((phoneType == 'INTL') && validINTL)) {
            // check work vs alternate and work vs primary
            if (work[0] != "") {
               if (work[0] == primary[0])
                  errorMsg = "Work phone number cannot be the same as the Primary phone number.  Please change or remove the duplicate.";
               if (work[0] == alternate[0]) {
                  if (errorMsg)
                     errorMsg += "<br/>Work phone number cannot be the same as the Alternate phone number.  Please change or remove the duplicate.";
                  else
                     errorMsg = "Work phone number cannot be the same as the Alternate phone number.  Please change or remove the duplicate.";
               }
            }
         } else if ((phoneType == 'INTL') && !validINTL) {
            errorMsg = "Work phone number that is International must include Country Code, City code, and Local.";
         }
      }
   }

   return errorMsg;
}
